module.exports = __webpack_public_path__ + "img/bullet_11.96d0880d.svg";